import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'

import { CheckboxStandalone } from 'Components/Form/CheckboxStandalone'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'

import { required } from 'Utils/Validators/formValidation'
import { Map } from 'Components/Map'
import pinIcon from '../../../../../Assets/Images/icons/mission-pin-vector.svg'

class LocationEditFormUnstyled extends React.Component {
  render() {
    const {
      className,
      handleSubmit,
      locationTypeOptions,
      location,
    } = this.props
    return (
      <form className={className} onSubmit={handleSubmit}>
        <Row>
          <Col xs={6}>
            <Field
              component={Input}
              name="name"
              props={{ id: 'name', label: 'Name', placeholder: 'Name' }}
              validate={[required]}
            />
          </Col>
          <Col xs={6}>
            <Field
              component={Input}
              name="label"
              props={{ id: 'label', label: 'Label', placeholder: 'Label' }}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              component={CheckboxStandalone}
              name="isEvent"
              props={{ label: 'Event or Weekend' }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              name="typeId"
              component={SelectDashboard}
              props={{
                onChange: this.typeSelectHandler,
                /* TODO: temporary solution, waiting for more details */
                options: locationTypeOptions,
                label: 'Type',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Map
              defaultZoom={14}
              mapPositionLat={Number(location.coordinates.latitude)}
              mapPositionLng={Number(location.coordinates.longitude)}
              markers={[
                {
                  markerPositionLat: Number(location.coordinates.latitude),
                  markerPositionLng: Number(location.coordinates.longitude),
                  isMarkerDraggable: false,
                  useDefaultIcon: true,
                  icon: pinIcon,
                },
              ]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Field
              component={CheckboxStandalone}
              name="moments.morning"
              props={{ label: 'Morning' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={CheckboxStandalone}
              name="moments.lunch"
              props={{ label: 'Lunch' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={CheckboxStandalone}
              name="moments.afternoon"
              props={{ label: 'Afternoon' }}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={4}>
            <Field
              component={CheckboxStandalone}
              name="isSheltered"
              props={{ label: 'Sheltered' }}
            />
          </Col>
          <Col xs={4}>
            <Field
              component={CheckboxStandalone}
              name="status"
              props={{ label: 'Active' }}
            />
          </Col>
        </Row>
      </form>
    )
  }

  typeSelectHandler = (e, index, value) => {
    const { change } = this.props
    change('typeId', value)
  }
}

LocationEditFormUnstyled.propTypes = {
  locationTypeOptions: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

LocationEditFormUnstyled = reduxForm({
  enableReinitialize: true,
  form: 'locationEditForm',
})(LocationEditFormUnstyled)

const mapStateToProps = state => ({
  initialValues: {
    ...state.locations.locationById,
  },
})

LocationEditFormUnstyled = connect(
  mapStateToProps,
  {},
)(LocationEditFormUnstyled)

export default LocationEditFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Locations/LocationEdit/unstyled.js